import type { ReactNode } from 'react'
import { FlashIcon } from '@repo/ui'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'

type Props = Readonly<{
  actions?: ReactNode
}>

export function ShowGamesTitle({ actions }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div className="show-games-title">
      <div className="icon">
        <FlashIcon className="text-yellow" />
      </div>

      <h2>{t('All Live Tracks')}</h2>

      {actions ? <div className="show-games-title__actions">{actions}</div> : null}
    </div>
  )
}